<div class="app-address-form">
  <!-- Row 1: CEP | Rua/Avenida -->
  <div class="app-address-form__row">
    <div class="app-address-form__field">
      <aprova-input
        [control]="form.controls.cep"
        class="w-full"
        label="CEP"
        tabindex="1"
        inputMode="numeric"
        mask="00000-000"
        [required]="true"
        [disabled]="isFieldBlocked('cep')"
        [errorMessages]="{
          required: 'Por favor preencha o campo CEP.'
        }"
      >
        @if (loading()) {
          <aprova-loading-spinner append size="xs" color="#06929F" />
        }
      </aprova-input>
      @if (cepNotice() === 'not_found') {
        <p class="app-address-form__cep-notice app-address-form__cep-notice--error">
          CEP não encontrado. Verifique se está correto.
        </p>
      } @else if (cepNotice() === 'unavailable') {
        <p class="app-address-form__cep-notice app-address-form__cep-notice--warning">
          Não conseguimos validar o CEP no momento. Preencha o endereço manualmente.
        </p>
      }
    </div>

    <div class="app-address-form__field">
      <aprova-input
        #inputStreet
        [control]="form.controls.rua"
        class="w-full"
        label="Rua/Avenida"
        tabindex="2"
        [required]="true"
        maxlength="255"
      />
    </div>
  </div>

  <!-- Row 2: Número (with Sem número checkbox) | Complemento -->
  <div class="app-address-form__row">
    <div class="app-address-form__field app-address-form__field--with-checkbox">
      <aprova-input
        #inputNumber
        inputType="number"
        inputMode="numeric"
        class="w-full"
        [control]="form.controls.numero"
        label="Número"
        tabindex="3"
        maxlength="144"
        [required]="!noNumberAddress()"
        [disabled]="isFieldBlocked('numero') || noNumberAddress()"
      />
      <!-- Sem número checkbox inside the field area -->
      <div class="app-address-form__no-number">
        <aprova-checkbox
          [checked]="noNumberAddress()"
          (onChange)="toogleNoNumberAddress()"
        >
          <span class="app-address-form__no-number-label">Sem número</span>
        </aprova-checkbox>
      </div>
    </div>

    <div class="app-address-form__field">
      <aprova-input
        [control]="form.controls.complemento"
        class="w-full"
        label="Complemento (opcional)"
        tabindex="4"
        [required]="false"
        [disabled]="isFieldBlocked('complemento')"
      />
    </div>
  </div>

  <!-- Row 3: Bairro | Cidade -->
  <div class="app-address-form__row">
    <div class="app-address-form__field">
      <aprova-input
        #inputNeighborhood
        [control]="form.controls.bairro"
        class="w-full"
        label="Bairro"
        tabindex="5"
        [required]="true"
        [disabled]="isFieldBlocked('bairro')"
        [errorMessages]="{
          required: 'Preencha corretamente seu bairro.'
        }"
      />
    </div>

    <div class="app-address-form__field">
      <aprova-input
        [control]="form.controls.cidade"
        class="w-full"
        label="Cidade"
        tabindex="6"
        [required]="true"
        [disabled]="isFieldBlocked('cidade')"
        [errorMessages]="{
          required: 'Preencha corretamente sua cidade.'
        }"
      />
    </div>
  </div>

  <!-- Row 4: Estado (alone) -->
  <div class="app-address-form__row app-address-form__row--half">
    <div class="app-address-form__field">
      <aprova-input
        [control]="form.controls.estado"
        class="w-full"
        label="Estado"
        tabindex="7"
        [required]="true"
        [disabled]="isFieldBlocked('estado')"
        [errorMessages]="{
          required: 'Preencha corretamente seu estado.'
        }"
      />
    </div>
  </div>

  @if (isLastStep) {
  <div class="app-address-form__terms">
    <aprova-checkbox
      [control]="form.controls.termos"
      class="font-normal text-sm leading-4 text-gray-500"
      color="#06929F"
    >
      Li e aceito os
      <a
        href="https://assets-publicos.s3.amazonaws.com/Termos+de+Uso.pdf"
        target="_blank"
        class="app-address-form__terms-link"
      >
        termos de uso
      </a>
    </aprova-checkbox>
  </div>

  @if(!hideRecaptcha){
  <aprova-recaptcha [recaptchaFormControl]="form.controls.recaptchaReactive" />
  } }
</div>
